import {Inject, Injectable, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from 'angular-auth-oidc-client';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  developingMode = false;
  api = 'https://engine.charity.elimedi.com';

  constructor(private http: HttpClient,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              public oidcSecurityService: OidcSecurityService) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, lan_id) {
    this.session.set('dir', language);
    this.session.set('lang', lan_id);
  }

  apiCall(method, route, body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    if (method == 'post') {
      return this.http.post(this.api + route, body, {headers})
    } else if (method == 'get') {
      return this.http.get(this.api + route, {headers})
    } else if (method == 'delete') {
      return this.http.delete(this.api + route, {headers})
    } else if (method == 'put') {
      return this.http.put(this.api + route, body, {headers})
    }
  }

  GetLanguages() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/admin/GetLanguages', {headers});
  }

  RegisterConfirm() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/Account/RegisterConfirm', {headers});
  }

// ----------------charity----------------
  GetCountries() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.get(this.api + '/api/admin/GetCountries/' + this.session.get('lang'), {headers});
  }

  Getcities(provinceid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.get(this.api + '/api/admin/Getcities/' + this.session.get('lang') + '/' + provinceid, {headers});
  }

  GetProvinces(countryid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.get(this.api + '/api/admin/GetProvinces/' + this.session.get('lang') + '/' + countryid, {headers});
  }

  GetAllUsers(body) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.post(this.api + '/api/admin/GetAllUsers/' + this.session.get('lang'), body, {headers});
  }

  GetCharities(body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.post(this.api + '/api/admin/GetCharities/' + this.session.get('lang'), body, {headers});
  }

  GetImage(Md5) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });

    return this.http.get(this.api + '/api/image/GetImage/' + Md5, {headers});
  }

  GetCharityinfo(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.get(this.api + '/api/admin/GetCharityinfo/' + this.session.get('lang') + '/' + id, {headers});
  }

  ToggleRole(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      'lang': this.session.get('lang')
    });
    return this.http.post(this.api + '/api/admin/ToggleRole/', body, {headers});
  }

  GetAllTags() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.get(this.api + '/api/admin/GetAllTags/' + this.session.get('lang'), {headers});
  }

  AddTags(body) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.post(this.api + '/api/admin/AddTags/', body, {headers});
  }

  DeleteTag(id) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.delete(this.api + '/api/admin/DeleteTag/' + id, {headers});
  }

  AddCharity(body) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.post(this.api + '/api/admin/AddCharity', body, {headers});
  }

  editcharity(charityId) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.get(this.api + '/api/admin/editcharity/' + this.session.get('lang') + '/' + charityId, {headers});
  }

  ShowYourCharities() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.get(this.api + '/api/CharityManagerAccounting/ShowYourCharities/' + this.session.get('lang'), {headers});
  }

  UpdateCharity(body, id) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.post(this.api + '/api/CharityManager/UpdateCharity/' + id, body, {headers});
  }

  EditTag(id) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.get(this.api + '/api/Admin/EditTag/' + id, {headers});
  }

  UpdateTag(body, id) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.session.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.post(this.api + '/api/Admin/UpdateTag/' + id, body, {headers});
  }

}
